import {Card, CardContent} from "@mui/material";

import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";

function Points(props) {
    const { points } = props;
    return(
        <Card sx={{height: "100%"}}>
            <CardContent>
                <Typography fontFamily="Mossport" sx={{ fontSize: 25 }} color="text.secondary" gutterBottom>
                    БАЛЛЫ
                </Typography>
                <Typography sx={{marginTop: 5}} textAlign="center" component="div">
                    Вы заработали
                </Typography>
                <Typography data-testid="points" textAlign="center" variant="h2" component="div">
                    {points}
                </Typography>
                <Typography textAlign="center" component="div">
                    Баллов
                </Typography>
            </CardContent>
        </Card>
    );
}

Points.propTypes = {
    points: PropTypes.any,
};

export default Points;